const pageNames = Object.freeze({
  // <---- Channel Steering Page Group ---->
  contactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-us:::',
  },
  callUsPage: {
    pageGroupName: 'main:help:smart::callus',
    pageName: 'main:help:smart::callus:::',
  },
  emailPage: {
    pageGroupName: 'main:help:smart::email',
    pageName: 'main:help:smart::email:::',
  },
  emailByPassPage: {
    pageGroupName: 'main:help:smart::emailByPass',
    pageName: 'main:help:smart::emailByPass:::',
  },

  // <---- HCR Page Group ---->
  homePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
  },
  searchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search:::',
  },
  articlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
  },
  topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
  },

  // <---- Special Component Group ---->
  ErrorPage: {
    pageGroupName: 'main:help:smart::error',
    pageName: 'main:help:smart::error:::',
  },
  intermediatePage: {
    pageGroupName: 'main:help:smart::intermediate',
    pageName: 'main:help:smart::intermediate:::',
  },
  chat: {
    pageGroupName: 'main:help:smart::chat',
    pageName: 'main:help:smart::chat:::',
  },
  hero: {
    pageGroupName: 'main:help:smart::heromodule',
    pageName: 'main:help:smart::heromodule:::',
  },
});

const PageMapping = {
  'contact-us': 'contactUsPage',
  callus: 'callUsPage',
  email: 'emailPage',
  home: 'homePage',
  search: 'searchPage',
  article: 'articlePage',
  topic: 'topicPage',
};

module.exports = {
  pageNames,
  PageMapping,
};
